import * as React from 'react'
import styles from './styles.module.css'
import { PRIMARY_CONTENT_ATTRIBUTE } from './useSidebarBottomOffset'

export function PrimaryContent({ children }: React.PropsWithChildren) {
  return (
    <div
      {...{ [PRIMARY_CONTENT_ATTRIBUTE]: '' }}
      className={
        styles.primaryContent
      }
    >
      {children}
    </div>
  )
}
